import { render, staticRenderFns } from "./l-consommable.html?vue&type=template&id=46d7a0b8&scoped=true&external"
import script from "./l-consommable.js?vue&type=script&lang=js&external"
export * from "./l-consommable.js?vue&type=script&lang=js&external"
import style0 from "./l-consommable.scss?vue&type=style&index=0&id=46d7a0b8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7a0b8",
  null
  
)

export default component.exports